import React, { useMemo } from "react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import PatientsDashboard from "../patients/PatientsDashboard";
import Studies from "../studies/StudiesDashboard";
import { useAppSelector } from "../../app/hooks";
import { selectCurrentPatient } from "../patients/patientsSlice";
import { Drawer } from "@mui/material";
import { Box } from "@mui/system";
import useResize from "../../hooks/useResize/useResize";

const Layout: React.FC = () => {
    const currentPatient = useAppSelector(selectCurrentPatient);
    const theme = useTheme();
    const { width: adaptableWidth, enableResize, isResizing } = useResize({ minWidth: 700, inverse: true });
    const isLargeScreen = useMediaQuery(theme.breakpoints.up("lg"));

    const isStudiesDrawerOpen = Boolean(currentPatient);

    const mainStyle = useMemo(() => {
        return {
            height: "100%",
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            padding: 4,
            transition: "margin 0.2s ease",
            marginRight: {
                lg: -adaptableWidth,
            },
            ...(isStudiesDrawerOpen && {
                marginRight: 0,
                transition: "margin 0.2s ease-out",
            }),
        };
    }, [adaptableWidth, isStudiesDrawerOpen]);

    return (
        <Box sx={{ display: "flex", height: "calc(100% - 65px)" }}>
            <Box sx={mainStyle}>
                <PatientsDashboard />
            </Box>
            <Drawer
                anchor={isLargeScreen ? "right" : "bottom"}
                variant={isLargeScreen ? "persistent" : "temporary"}
                sx={{
                    "width": {
                        lg: adaptableWidth,
                    },
                    "flexShrink": {
                        lg: 0,
                    },
                    "pointerEvents": isStudiesDrawerOpen ? "initial" : "none",
                    "& .MuiDrawer-paper": {
                        lg: {
                            height: "calc(100% - 64px)",
                            top: "64px",
                            width: adaptableWidth,
                        },
                    },
                }}
                open={isStudiesDrawerOpen}
            >
                <Box
                    style={{
                        position: "absolute",
                        paddingRight: 32,
                        top: "0",
                        left: "-1px",
                        bottom: "0",
                        cursor: "ew-resize",
                    }}
                    onMouseDown={enableResize}
                >
                    <Box
                        style={{
                            width: "3px",
                            height: "100%",
                            backgroundColor: isResizing ? "#90caf9" : "transparent",
                            boxShadow: isResizing ? "rgb(144 202 249) -7px 2px 32px 1px" : "none",
                        }}
                    />
                </Box>

                {currentPatient && <Studies key={currentPatient?.uuid} />}
            </Drawer>
        </Box>
    );
};

export default Layout;
